import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const STORAGE_KEY = 'mm_admin_auth_v2';
const SESSION_DAYS = 7;

// Install once at module load (before any component mounts): inject admin token into /api requests
const _origFetch = window.fetch.bind(window);
window.fetch = (url, opts = {}) => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && saved.token && typeof url === 'string' && url.includes('/api/')) {
      opts = { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${saved.token}` } };
    }
  } catch (e) { /* noop */ }
  return _origFetch(url, opts);
};

const AdminGate = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && saved.token && saved.expires > Date.now()) setAuthed(true);
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) { console.error('Read admin auth from storage failed:', e); }
  }, []);

  // Inject admin token into all /api requests made from admin pages (installed at module load above)

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (res.status === 429) {
        setError('बहुत सारे गलत प्रयास — 15 मिनट बाद try करें');
        setLoading(false);
        return;
      }
      const data = await res.json();
      if (data.success && data.token) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          token: data.token,
          expires: Date.now() + SESSION_DAYS * 86400000,
        }));
        setAuthed(true);
      } else {
        setError(data.error || 'गलत password');
      }
    } catch (e) {
      setError('Network error: ' + e.message);
    }
    setLoading(false);
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setAuthed(false);
    setPassword('');
  };

  if (authed) {
    return (
      <div>
        <button onClick={logout} data-testid="admin-logout-btn"
          className="fixed bottom-4 right-4 z-40 px-3 py-1.5 bg-gray-900 text-white text-xs font-bold rounded-lg shadow-lg opacity-60 hover:opacity-100">
          🔒 Logout
        </button>
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg,#3B0E0E 0%,#5B1818 50%,#3B0E0E 100%)', fontFamily: "'Noto Sans Devanagari',sans-serif" }} data-testid="admin-gate">
      <div className="bg-white max-w-sm w-full rounded-2xl shadow-2xl p-7 border-2"
        style={{ borderColor: '#C9A23A' }}>
        <div className="text-center mb-6">
          <div className="text-3xl mb-2" style={{ color: '#C9A23A' }}>ॐ</div>
          <h1 className="text-2xl font-bold" style={{ color: '#5B1818', fontFamily: "'Tiro Devanagari Hindi',serif" }}>
            गुप्त प्रवेश द्वार
          </h1>
          <p className="text-sm mt-1" style={{ color: '#5A3A28' }}>केवल माता मलिहा जी की सेवा-दल हेतु</p>
        </div>
        <form onSubmit={submit}>
          <label className="text-xs font-bold block mb-1" style={{ color: '#5B1818' }}>गुप्त संकेत (Password)</label>
          <input
            type="password" value={password} onChange={e => setPassword(e.target.value)}
            autoFocus required data-testid="admin-password-input"
            className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none text-base"
            style={{ borderColor: error ? '#B22222' : '#C9A23A' }}
            placeholder="गुप्त संकेत दर्ज करें" />
          {error && (
            <div className="text-sm mt-2" style={{ color: '#B22222' }} data-testid="admin-error">{error}</div>
          )}
          <button
            type="submit" disabled={loading || !password} data-testid="admin-submit-btn"
            className="w-full mt-5 py-3 rounded-full text-base font-extrabold transition-all transform hover:scale-105 disabled:opacity-50 disabled:scale-100"
            style={{ background: 'linear-gradient(135deg,#C9A23A 0%,#E2C170 50%,#C9A23A 100%)', color: '#2A1208', boxShadow: '0 4px 16px rgba(201,162,58,0.4)' }}>
            {loading ? 'जाँच रहे हैं...' : 'प्रवेश करें'}
          </button>
        </form>
        <p className="text-xs text-center mt-5" style={{ color: '#5A3A28' }}>
          ❖ जय माता मलिहा ❖
        </p>
      </div>
    </div>
  );
};

export default AdminGate;
